import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { CountryPrefix } from '@crehana/ts-types';

import { LandingNameEnum } from '@/shared/types/graphql/globals';

import QUERY_HOME_SEO from '../graphql/HomepageSEOQuery.graphql';
import { getDefaultSeoHomepage, SEO_TEMPORAL_FIX } from '../constants';
import {
  HomepageSEOQuery,
  HomepageSEOQueryVariables,
} from '../graphql/types/HomepageSEOQuery';

interface SeoReturnType {
  metaTitle: string;
  metaDescription: string;
}

const getSeoHomepage = async (
  apolloClient: ApolloClient<NormalizedCacheObject>,
  countryPrefix?: CountryPrefix | null,
): Promise<SeoReturnType> => {
  try {
    const { data: seoHomepage } = await apolloClient.query<
      HomepageSEOQuery,
      HomepageSEOQueryVariables
    >({
      query: QUERY_HOME_SEO,
      variables: {
        landingNameEnum: LandingNameEnum.home,
      },
    });
    const metaTitle = seoHomepage?.seoLandingEnum?.title;
    const metaDescription = seoHomepage?.seoLandingEnum?.description;

    if (seoHomepage && seoHomepage.seoLandingEnum) {
      return {
        metaTitle: metaTitle || SEO_TEMPORAL_FIX.default.metaTitle,
        metaDescription:
          metaDescription || SEO_TEMPORAL_FIX.default.metaDescription,
      };
    }
    throw new Error('seoLandingEnum query has failed');
  } catch (error) {
    console.error(error);
    return getDefaultSeoHomepage(countryPrefix);
  }
};

export default getSeoHomepage;
